import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "react-slick";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Slide from "@material-ui/core/Slide";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { API_BASE_URL } from "views/api";


// Sections for this page
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(styles);
Transition.displayName = "Transition";

const description_map = {
  'intro': API_BASE_URL + 'homepage/district-info/',
  'intro/changunarayan': API_BASE_URL + 'introduction/infos/?administrative_unit=changunarayan',
  'intro/bhaktapur': API_BASE_URL + 'introduction/infos/?administrative_unit=bhaktapur',
  'intro/madhyapur_thimi': API_BASE_URL + 'introduction/infos/?administrative_unit=madhyapur_thimi',
  'intro/suryabinayak': API_BASE_URL + 'introduction/infos/?administrative_unit=suryabinayak'
}

export default function ProductSection(props) {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };
  var HtmlToReactParser = require('html-to-react').Parser;

  const [html_content, setHTMLContent] = React.useState(undefined);

  React.useEffect(() => {
    if (html_content === undefined) {
      fetch(description_map[props.link])
        .then(results => results.json())
        .then(data => {
          setHTMLContent(data.results[0]);
        });
    }
  });

  var htmlInput = (html_content && html_content.description) || '<div class="lds-ellipsis extra-color-blue"><div></div><div></div><div></div><div></div></div>';
  var htmlToReactParser = new HtmlToReactParser();
  var reactElement = htmlToReactParser.parse(htmlInput);

  const [classicModal, setClassicModal] = React.useState(false);

  return (
    <div className={classes.section}>
      <GridContainer>
        {(props.link !== "intro" || props.homepage) &&
          <GridItem xs={12} sm={12} md={6}>
            <Card carousel>
              <Carousel {...settings}>
                {html_content && html_content.images && html_content.images.map((image) =>
                  <div>
                    <img src={image.image} alt="First slide" className="slick-image" />
                    <div className="slick-caption">
                      <h4 style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
                        {image.title}
                      </h4>
                    </div>
                  </div>
                )}
              </Carousel>
            </Card>
          </GridItem>
        }
        <GridItem className="page-description-override-for-paragraph" xs={12} sm={12} md={(props.link === "intro" && !props.homepage) ? 12 : 6} style={(props.link !== "intro" || props.homepage) ? { textAlign: 'left' } : {}}>
          {/*<div style={{ color: '#333' }}>{reactElement}</div>*/}
          {(props.link === "intro" && !props.homepage) &&
            <div style={{ color: "#134c7a", margin: 0 }}>
              
                <small>{props.info.title}</small>
              
              <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>{props.info.name}</h3></span>
              <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
            </div>
          }
          {(props.link !== "intro" || props.homepage) &&
            <div style={{ paddingLeft: '10px', color: "#134c7a", margin: 0, borderLeft: "5px solid #134c7a" }}>
              
              <small>{props.info.title}</small>
              <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>{props.info.name}</h3></span>
            </div>}
          <h5 className={classes.description} style={{ textAlign: 'left', color: '#333' }}>
            <HTMLEllipsis
              unsafeHTML={(html_content && html_content.description) || '<div class="lds-ellipsis extra-color-blue"><div></div><div></div><div></div><div></div></div>'}
              maxLine={(props.link === "intro" && !props.homepage) ? '3' : '12'}
              ellipsis='. . .'
              basedOn='letters'
              style={{ color: '#333' }}
            />
          </h5>
        </GridItem>

        {!props.homepage && !props.municipality_page &&
          <GridContainer style={{ margin: 'auto' }}>
            <GridItem xs={12} sm={12} md={6} lg={4}>
              <Button
                color="primary"
                onClick={() => setClassicModal(true)}
              >
                थप पढ्नुहोस्
              </Button>
              <Dialog
                classes={{
                  root: classes.center,
                  paper: classes.modal
                }}
                open={classicModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setClassicModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
              >
                <DialogTitle
                  id="classic-modal-slide-title"
                  disableTypography
                  className={classes.modalHeader}
                >
                  <IconButton
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={() => setClassicModal(false)}
                    style={{ float: 'right' }}
                  >
                    <Close className={classes.modalClose} />
                  </IconButton>
                  <div style={{ paddingLeft: '10px', color: "#134c7a", margin: 0, borderLeft: "5px solid #134c7a" }}>
                    <small>{props.info.title}</small>
                    <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a' }}>{props.info.name}</h3></span>
                  </div>
                </DialogTitle>
                <DialogContent
                  id="classic-modal-slide-description"
                  className={classes.modalBody}
                >

                  <h5 className={classes.description} style={{ textAlign: 'left', color: '#333' }}>
                    {reactElement}
                  </h5>
                </DialogContent>
                <DialogActions className={classes.modalFooter}>
                  <Button
                    onClick={() => setClassicModal(false)}
                    color='primary'
                  >
                    बन्द
                  </Button>
                </DialogActions>
              </Dialog>
            </GridItem>
          </GridContainer>
        }
        {(props.homepage || props.municipality_page) && <Button style={{ margin: 'auto', width: '300px' }} href={`/${props.link}`} color="primary">थप जानकारी</Button>}
      </GridContainer>
    </div>
  );
}
